<template>
  <button
    id="click4"
    class="polis-btn"
    @click="isOpen = true, $refs.myForm.resetForm()"
  >
    {{ $t("buttons.polis") }}
  </button>
  <modal
    :pName="pName"
    :open="isOpen"
    @close="isOpen = !isOpen"
  >
    <get-discount />
    <Form
      ref="myForm"
      @submit="Send"
    >
      <div class="modal-inputs">
        <div class="err-message">
          <Field
            v-model="GuestName"
            name="username"
            type="text"
            class="name"
            :placeholder="$t('placeholder.name')"
            :rules="requiredName"
            @keyup="onlyText()"
          />
          <div
            :class="{ remove: IsRemove }"
            class=""
          >
            <ErrorMessage name="username" />
          </div>
        </div>
        <!-- <input v-model="GuestEmail" type="email" name="" :placeholder="$t('placeholder.email')"/> -->
        <div class="err-message">
          <Field
            v-model="GuestPhone"
            v-mask="'+7(7##)-###-##-##'"
            type="text"
            name="phone"
            :placeholder="$t('placeholder.phone')"
            :rules="requiredNum"
          />
          <div
            :class="{ remove: IsRemove }"
            class=""
          >
            <ErrorMessage name="phone" />
          </div>
        </div>
        <div class="err-message">
          <Field
            v-model="organization_name"
            type="text"
            :placeholder="$t('placeholder.company')"
            name="organization"
            :rules="requiredNum"
          />
          <div
            :class="{ remove: IsRemove }"
            class=""
          >
            <ErrorMessage name="organization" />
          </div>
        </div>
        <textarea
          v-model="guest_desc"
          :placeholder="$t('placeholder.com')"
        />
      </div>
      <div class="modal-btn">
        <button
          type="submit"
          :class="{isDisabled : disabled}"
          @click="buttonClicked"
        >
          <div
            v-if="loading"
            class="spinner-border spinner-border-sm"
          />
          {{ $t("buttons.send") }}
        </button>
      </div>
      <div class="modal-rule">
        <input
          id="check"
          v-model="checked"
          type="checkbox"
        >
        <label for="check">{{ $t("modal.check1") }}
          <a href="/condition">{{ $t("modal.check2") }}</a></label>
      </div>
    </Form>
  </modal>
</template>

<script>
import getDiscount from "./getDiscount.vue";
import axios from "axios";
import { ref } from "vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import modal from "../components/windows/modal.vue";
import { Buffer, resolveObjectURL } from "buffer";
import { useToast } from "vue-toastification";
const toaster = useToast()
export default {
  components: { getDiscount, modal, Field, Form, ErrorMessage },
  props: ["pName"],
  setup() {
    const isOpen = ref(false);
    return { isOpen };
  },
  data() {
    return {
      loading: false,
      GuestName: null,
      GuestPhone: null,
      disabled: false,
      organization_name: null,
      guest_desc: null,
      checked: false,
      IsRemove: false,
    };
  },
  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.documentElement.style.overflow = "hidden";
        return;
      }
      document.documentElement.style.overflow = "auto";
      this.GuestName = "";
      this.GuestPhone = "";
      this.organization_name = "";
      this.guest_desc = "";
      this.checked = false;
      this.IsRemove = true;
    },
  },
  methods: {
    onlyText() {
      this.GuestName = this.GuestName.replace(
        /[^а-яА-ЯёЁәӘіІңҢғҒүҮұҰқҚөӨһҺa-zA-Z\-\s]/gi,
        ""
      );
    },
    buttonClicked() {
      this.disabled = !false;
      // alert("clicked!");
      setTimeout(() => (this.disabled = !true), 5000);
    },
    validateEmail(value) {
      if (!value) {
        return this.$t("placeholder.req");
      }
      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(value)) {
        return this.$t("placeholder.reqEmail");
      }
      return true;
    },
    requiredName(value) {
      if (!value) {
        return this.$t("placeholder.req");
      }
      return true;
    },
    requiredNum(value) {
      if (!value) {
        return this.$t("placeholder.req");
      }
      return true;
    },
    Send(values, {resetForm}) {
      if (this.checked === true) {
        const auth = new Buffer("Nomad:Qwerty123", "utf-8").toString("base64");
        this.form = {
          username: this.GuestName,
          form_name: "discount",
          organization_name: this.organization_name,
          phone: this.GuestPhone,
          // email: this.GuestEmail,
          description: this.guest_desc,
          product_name: this.pName,
        };
        axios
          .post("https://bitrix24.cic.kz/api/crm/leads/create/", this.form, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-type": "application/json",
              Authorization: "Basic " + auth,
            },
          })
          .then((res) => {
            if (res.data.status == true) {
              this.loading = !false;
              setTimeout(() => (this.loading = !true), 3000);
              toaster.success(this.$t('notification.success'), {
                  position: "top-right"
                });
              resetForm();
              setTimeout(()=> (this.isOpen = false), 500)
            } else {
              toaster.error(this.$t('notification.req'), {
                  position: "top-right"
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toaster.error(
          this.$t('notification.dontagree'), {
                  position: "top-right"
                }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 768px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 768px) and (max-width: 1024px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1024px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1620px) and (max-width: 2560px) {
    @content;
  }
}
.err-message {
  display: block;
  span {
    @include fontStyle(Roboto, normal, 400, 16px, 20px, red);
    padding-top: 5px;
  }
  @include tablet-1024() {
    span {
      font-size: 8px;
      line-height: 12px;
    }
  }
  @include desktop() {
    span {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
.polis {
  &-btn {
    background: #efefef;
    border-radius: 15px;
    width: 200px;
    height: 70px;
    border: none;
    color: #373737;
    @include fontStyle(Roboto, normal, 600, 18px, 25px, #373737);
    &:hover {
      background: linear-gradient(
        90deg,
        #ff4466 0%,
        #be31ce 49.97%,
        #3641ff 100%
      );
      color: #ffffff;
    }
  }
  @include mobile() {
    &-btn {
      // text-align: center;
      margin-bottom: 0px;
      border-radius: 5px;
      width: 130px;
      height: 34px;
      font-size: 12px;
    }
  }
  @include tablet() {
    &-btn {
      text-align: center;
      border-radius: 5px;
      width: 130px;
      height: 34px;
      font-size: 12px;
    }
  }
  @include tablet-1024() {
    &-btn {
      text-align: center;
      width: 150px;
      height: 50px;
      border-radius: 8px;
      font-size: 12px;
    }
  }
}
</style>
